// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RoutesProgress.module.css **/

.RoutesProgress_routesProgressRoot__4KjOy {
  font-family: "Segoe UI", Calibri, Candara, Arial, sans-serif;
  height: calc(100vh - 145px);
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}

.RoutesProgress_routesProgressRoot__4KjOy h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 24px;
}

/* Фильтры: на десктопе — 4 в ряд (label+field ×2) */
.RoutesProgress_filtersContainer__KZD9V {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 24px;
  row-gap: 12px;
  align-items: center;
  margin-bottom: 20px;
  column-gap: 24px;
  row-gap: 12px;
  align-items: center;
  margin-bottom: 20px;
}

.RoutesProgress_filtersContainer__KZD9V > .RoutesProgress_filterItem__IBC2F {
  display: flex;
  flex-direction: column;
}

.RoutesProgress_filtersContainer__KZD9V > .RoutesProgress_filterItem__IBC2F > label {
  font-size: 14px;
  margin-bottom: 4px;
  white-space: nowrap;
}

/* Универсальный стиль для всех полей ввода */
.RoutesProgress_filtersContainer__KZD9V input[type="date"],
.RoutesProgress_filtersContainer__KZD9V select {
  width: 100%;
  height: 34px;
  padding: 0 12px;
  font-size: 16px;
  line-height: 1.4;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 6px;
  background-color: #fff;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.RoutesProgress_filtersContainer__KZD9V input[type="date"]:focus,
.RoutesProgress_filtersContainer__KZD9V select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Планшеты */
@media (max-width: 1024px) {
  .RoutesProgress_filtersContainer__KZD9V {
    column-gap: 16px;
  }
}

/* Мобильная версия — 2×2 для фильтров */
@media (max-width: 768px) {
  .RoutesProgress_routesProgressRoot__4KjOy {
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
  }
  .RoutesProgress_filtersContainer__KZD9V {
    grid-template-columns: 1fr 1fr;
    column-gap: 12px;
    row-gap: 12px;
  }
}

/* Список маршрутов */
.RoutesProgress_routesContainer__mriGq {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding-bottom: 20px;
}

/* Карточка маршрута */
.RoutesProgress_routeCard__6KoP4 {
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}
/*.routeCard:hover {
  transform: translateY(-3px);
}*/

/* Заголовок карточки */
.RoutesProgress_routeHeader__wN\\+-b {
  display: flex;
  flex-wrap: nowrap;           /* Запрещаем перенос элементов */
  align-items: center;
  gap: 12px;                   /* Расстояние между водителем, грузчиками и иконкой */
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 14px;
}
@media (max-width: 768px) {
  .RoutesProgress_routeHeader__wN\\+-b {
    /* Убираем колонку и запрет переноса */
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;
    font-size: 13px;
  }
  .RoutesProgress_statusIcon__2s3Pn {
    /* Иконка по-прежнему справа */
    margin-left: auto;
  }
}

/* Иконка статуса */
.RoutesProgress_statusIcon__2s3Pn {
  font-size: 1.2rem;
}

/* Время последнего изменения */
.RoutesProgress_lastChange__25pTo {
  font-size: 12px;
  color: #666;
  margin-bottom: 10px;
}

/* Полоса прогресса */
.RoutesProgress_progressContainer__LR0tM {
  width: 100%;
}
.RoutesProgress_progressBar__DPJTr {
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  background-color: #e0e0e0;
}
.RoutesProgress_progressDelivered__cvpqD {
  background-color: rgb(40, 167, 69);
  flex-grow: 1;
}
.RoutesProgress_progressInProgress__xm8b3 {
  background-color: rgb(0, 123, 255);
  flex-grow: 1;
}
.RoutesProgress_progressUndelivered__k7v7B {
  background-color: rgb(220, 53, 69);
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Manager/RoutesProgress/RoutesProgress.module.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC;EACE,4DAA4D;EAC5D,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,aAAa;AACb;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,0BAA0B;EAC1B,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE;;AAEF,uBAAuB;AACvB;EACE,aAAa;EACb,iBAAiB,YAAY,gCAAgC;EAC7D,mBAAmB;EACnB,SAAS,oBAAoB,qDAAqD;EAClF,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE;IACE,sCAAsC;IACtC,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,QAAQ;IACR,eAAe;EACjB;EACA;IACE,8BAA8B;IAC9B,iBAAiB;EACnB;AACF;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,kCAAkC;EAClC,YAAY;AACd","sourcesContent":["/** RoutesProgress.module.css **/\r\n\r\n.routesProgressRoot {\r\n  font-family: \"Segoe UI\", Calibri, Candara, Arial, sans-serif;\r\n  height: calc(100vh - 145px);\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: transparent;\r\n}\r\n\r\n.routesProgressRoot h1 {\r\n  font-size: 28px;\r\n  font-weight: 700;\r\n  margin-bottom: 24px;\r\n}\r\n\r\n/* Фильтры: на десктопе — 4 в ряд (label+field ×2) */\r\n.filtersContainer {\r\n  display: grid;\r\n  grid-template-columns: repeat(4, 1fr);\r\n  column-gap: 24px;\r\n  row-gap: 12px;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n  column-gap: 24px;\r\n  row-gap: 12px;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.filtersContainer > .filterItem {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.filtersContainer > .filterItem > label {\r\n  font-size: 14px;\r\n  margin-bottom: 4px;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Универсальный стиль для всех полей ввода */\r\n.filtersContainer input[type=\"date\"],\r\n.filtersContainer select {\r\n  width: 100%;\r\n  height: 34px;\r\n  padding: 0 12px;\r\n  font-size: 16px;\r\n  line-height: 1.4;\r\n  color: #333;\r\n  border: 1px solid #ccc;\r\n  border-radius: 6px;\r\n  background-color: #fff;\r\n  box-sizing: border-box;\r\n  transition: border-color 0.2s, box-shadow 0.2s;\r\n}\r\n\r\n.filtersContainer input[type=\"date\"]:focus,\r\n.filtersContainer select:focus {\r\n  outline: none;\r\n  border-color: #007bff;\r\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n/* Планшеты */\r\n@media (max-width: 1024px) {\r\n  .filtersContainer {\r\n    column-gap: 16px;\r\n  }\r\n}\r\n\r\n/* Мобильная версия — 2×2 для фильтров */\r\n@media (max-width: 768px) {\r\n  .routesProgressRoot {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n    padding-top: 0px;\r\n  }\r\n  .filtersContainer {\r\n    grid-template-columns: 1fr 1fr;\r\n    column-gap: 12px;\r\n    row-gap: 12px;\r\n  }\r\n}\r\n\r\n/* Список маршрутов */\r\n.routesContainer {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n/* Карточка маршрута */\r\n.routeCard {\r\n  background-color: #fff;\r\n  padding: 15px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);\r\n  transition: transform 0.2s;\r\n  cursor: pointer;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n/*.routeCard:hover {\r\n  transform: translateY(-3px);\r\n}*/\r\n\r\n/* Заголовок карточки */\r\n.routeHeader {\r\n  display: flex;\r\n  flex-wrap: nowrap;           /* Запрещаем перенос элементов */\r\n  align-items: center;\r\n  gap: 12px;                   /* Расстояние между водителем, грузчиками и иконкой */\r\n  font-weight: 600;\r\n  margin-bottom: 8px;\r\n  font-size: 14px;\r\n}\r\n@media (max-width: 768px) {\r\n  .routeHeader {\r\n    /* Убираем колонку и запрет переноса */\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n    align-items: center;\r\n    gap: 8px;\r\n    font-size: 13px;\r\n  }\r\n  .statusIcon {\r\n    /* Иконка по-прежнему справа */\r\n    margin-left: auto;\r\n  }\r\n}\r\n\r\n/* Иконка статуса */\r\n.statusIcon {\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Время последнего изменения */\r\n.lastChange {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n/* Полоса прогресса */\r\n.progressContainer {\r\n  width: 100%;\r\n}\r\n.progressBar {\r\n  display: flex;\r\n  height: 10px;\r\n  border-radius: 5px;\r\n  overflow: hidden;\r\n  background-color: #e0e0e0;\r\n}\r\n.progressDelivered {\r\n  background-color: rgb(40, 167, 69);\r\n  flex-grow: 1;\r\n}\r\n.progressInProgress {\r\n  background-color: rgb(0, 123, 255);\r\n  flex-grow: 1;\r\n}\r\n.progressUndelivered {\r\n  background-color: rgb(220, 53, 69);\r\n  flex-grow: 1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"routesProgressRoot": `RoutesProgress_routesProgressRoot__4KjOy`,
	"filtersContainer": `RoutesProgress_filtersContainer__KZD9V`,
	"filterItem": `RoutesProgress_filterItem__IBC2F`,
	"routesContainer": `RoutesProgress_routesContainer__mriGq`,
	"routeCard": `RoutesProgress_routeCard__6KoP4`,
	"routeHeader": `RoutesProgress_routeHeader__wN+-b`,
	"statusIcon": `RoutesProgress_statusIcon__2s3Pn`,
	"lastChange": `RoutesProgress_lastChange__25pTo`,
	"progressContainer": `RoutesProgress_progressContainer__LR0tM`,
	"progressBar": `RoutesProgress_progressBar__DPJTr`,
	"progressDelivered": `RoutesProgress_progressDelivered__cvpqD`,
	"progressInProgress": `RoutesProgress_progressInProgress__xm8b3`,
	"progressUndelivered": `RoutesProgress_progressUndelivered__k7v7B`
};
export default ___CSS_LOADER_EXPORT___;
